<div class="coupon-card-root">
  <div class="content">
    <div class="header">
      <span class="equipment-data">{{equipmentName}}</span> <br>
      <span class="detailed-info">{{rewardName}}</span>
    </div>
    <div class="center">
      <div class="business-data">
        <app-epson-logo></app-epson-logo>
        <div class="coupon-info">
          <span class="business-name">{{businessName}}</span>
          <span class="printer-serial">{{equipmentSerial}}</span>
        </div>
      </div>
      <div class="rewards-data">
        <span class="discount-value">{{couponLabels.discountValue}} </span>
        <span class="value">{{rewardValue}}%</span>
      </div>
    </div>
    <span class="code">
      {{couponCode}}
    </span>
    <span class="country" *ngIf="countryName">
      {{couponLabels.couponValidCountry}}
    </span>
    <div class="bottom-area">
      <div class="dashed-line"></div>
      <div class="expiration-info">
      <app-chip small id="expiration-info" defaultCursor small filled [darkBlue]="isRedeemed" [red]="isCanceled" [yellow]="isExpiring" [gray]="isExpired" [green]="isActive">
        {{statusCheck[0] | transloco: { day: (calculateDaysToExpiration())} }} {{statusCheck[1] | date:'d MMM y' : '' :  language}}
      </app-chip>
    </div>
  </div>
</div>
